import React, { Component } from 'react';
import axios from 'axios';
import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "../../../custom-css/Custom.css";
import { getProducts, fetchData, getCartProducts, userlogin, updateProductQuantity, removeProduct, addPromocode, get_shipping_method, getOffers, get_user_lang } from '../../../repository';


let BASE_URL;
let ASSETS_URL;
let cart_url;
let checkout_url;
let home_url;

if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    BASE_URL = 'http://localhost:8001';
    ASSETS_URL = ""
}else if (window.location.hostname === 'dev.cocoonsealy.net'){
    BASE_URL = 'http://dev.cocoonsealy.net';
    ASSETS_URL = "http://dev.cocoonsealy.net"
}else if (window.location.hostname === 'staging.cocoonbysealy.ca'){
    BASE_URL = 'https://staging.cocoonbysealy.ca';
    ASSETS_URL = "https://staging.cocoonbysealy.ca"
}else{
    BASE_URL = 'https://cocoonbysealy.ca';
    ASSETS_URL = "https://assets-www.cocoonbysealy.ca"
}

class Basketitems extends Component {
    constructor(props) {
        super(props);        
            this.state = { 

            }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.products !== prevProps.products && this.props.products.length === 5) {
            // console.log(`products to retrieve details (Basket Page)`, this.props.products);
            this.query_products_detail();            
        }

        if (this.props.products_detail_temp !== prevProps.products_detail_temp  ){
            // console.log(`this.props.products_detail_temp.length (Basket Page) `, this.props.products_detail_temp.length);
            // console.log(`Props 2: `, this.props)
            this.init_products_meta_details();
        }

        if (this.props.products_detail !== prevProps.products_detail && this.props.products_detail.length === 5 ){            
            this.query_products_extra();            
        }
    }

    componentDidMount() {
        this.query_products(); 
    }

    query_products = () => {
        getProducts()

        .then((data) => {                        
           this.props.init_products(data);
        })        
        // console.log(`Products`, products);
    } 

    query_products_detail = () => {        
        let i=0;
        let products_data = this.props.products;
        let product_detail = [];
        let result;        
        let product_attribute;
        let product_attributes = [];
        let item_category;

        // console.log(`Aquiring Products Details begins `, this.props);

        for (i=0; i < products_data.length; i++) {                
            // console.log(`Product Url: `, products_data[i].url);
            // console.log(`Product Title: `, products_data[i].title);
            fetchData( products_data[i].url )

            .then( (data) => {                
                this.props.init_products_details_temp(data);
                // console.log(`Data: `, data);
                // this.state.temp_products_detail.concat(data);
            });            

            if (products_data[i].title === "Essential Medium") {
                item_category = 'cocoon-essential';
            } else if (products_data[i].title === "Cocoon Classic") {
                item_category = 'cocoon-classic';
            } else if (products_data[i].title.match(/Sealy Premium/g) ) {
                item_category = 'sealy-premium';
            } else if (products_data[i].title.match(/Sealy Performance/g) ) {
                item_category = 'sealy-performance';
            } else if (products_data[i].title.match(/Sealy Essential/g) ) {
                item_category = 'sealy-essential';
            }  
                        
            product_attribute = {
                category: item_category,                
                parent_id: products_data[i].id 
            }

            product_attributes = product_attributes.concat(product_attribute);  
        }        
        
        this.props.init_product_meta(product_attributes);

        // let data = this.props.child_products
        // let i=0;
        // for (i=0; i < data.length; i++) {
        //     // console.log(`Count .... ${i}`);
        //     this.getProductSku(data[i].sku_url, data[i].id, i);
        //     this.getProductPrice(data[i].price_url, data[i].id, i);
        //     this.getProductAvailabiliy(data[i].availability_url, data[i].id, i);
        // }
    }    

    init_products_meta_details = () => {
        // console.log(`temp products detail`, this.props.products_detail_temp);
        this.props.init_products_details(this.props.products_detail_temp);        
    }

    query_products_extra = () => {
        const products = this.props.products_detail;
        
        // console.log(`Basket Page Products Detail`, products);
        let i=0;
        for (i=0; i < products.length; i++) {
            // console.log(`product count : ${i} `);
            if (products[i].structure === 'standalone') {
                
                // get product price, sku, and availability
                this.get_product_price(products[i].id, products[i].price);
                this.get_product_sku(products[i].id, products[i].stockrecords);
                this.get_product_availability(products[i].id, products[i].availability)
            }else{
                // add child products
                // console.log(`Basket Page Add child Products`, products[i].children);
                this.add_child_products(products[i].children, products[i].product_class, products[i].id);
                           
            }
            

            
        }        
                
    }

    add_child_products = (children, category, parent_id) => {
        let i=0;
        
        let data;        
        for (i=0; i < children.length; i++) {
            // children[i].title
            data = {id: category, product: children[i]}
            this.props.set_child_products(data);
            this.get_children_product_detail(children[i]);            
        }
                
    }

    get_product_meta_data = (category) => {
        const data=this.props.parent_products_meta_data;
        console.log(`category ${category} data`, data);
        const attributes = data.filter(item => item.category === category);
        return attributes;
    }

    get_product_price = (id, url) => {
        
        fetchData(url).then( (response) => {             
            // console.log(`Response Price: `, response);    
            this.props.set_product_price(response, id);                        
        });
        
    }

    get_product_sku = (id, url) => {
        fetchData(url).then( (response) => {       
            // console.log(`Response SKU: `, response);
            this.props.set_product_sku(response[0].partner_sku, id);
        });        
    }

    get_product_availability = (id, url) => {
        fetchData(url).then( (response) => {        
            // console.log(`Response Availability: `, response);    
            this.props.set_product_availability(response, id);                        
        });     
    }

    get_children_product_detail = (products) => {        
        // console.log(`Add child Products Detail`, products);
                
        // console.log(`Products ULR: `, products.url);  
        fetchData(products.url).then( (response) => {
            // console.log(`Response Product: `, response);  
            this.props.set_child_products_detail(response);
            this.get_product_price(response.id, response.price);
            this.get_product_sku(response.id, response.stockrecords);
            this.get_product_availability(response.id, response.availability);
        });
                
    }

    render(){
        return(
            <React.Fragment >                
                <Loader type="ThreeDots" color="#f9bd4f" height={80} width={80} visible={this.props.page_loading} className="myload" />   
                <div className={this.props.page_loading === true ?'hide-show':''} >
                    <div className="basket l-capped-width">
                        <div className="basket-lines">
                            <div className="basket-lines__block">
                                <div className="basket-lines__header">
                                    <h1 className="basket-lines__header-title">{this.props.userlang ==='fr'? 'Votre panier': 'Your Cart'} <span
                                            className="basket-lines__header-title--count">({this.props.numProducts} {this.props.userlang ==='fr'? 'articles': 'items'})</span></h1>
                                </div>

                                <div className="basket-lines__content">
                                    <div>
                                        {/** Basket Item Row */}
                                        {this.props.basket_lines.map( (line, index) => (
                                            <div key={index} className="basket-line basket-line--full transition--fade-enter-done">
                                                <div className="basket-line__graphic">
                                                    
                                                    <a
                                                        href={ this.props.get_product_url(line.product) }>
                                                    {                                                        
                                                        (() => {
                                                            if (this.props.get_product_category(line.product) === "cocoon-classic") {
                                                                return (
                                                                <img src={ASSETS_URL + "/media/original_images/cocoon_classic.original.jpg"}
                                                                className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />)
                                                            } else if (this.props.get_product_category(line.product) === "cocoon-essential") {
                                                                return(
                                                                    <img src={ASSETS_URL + "/media/original_images/Cocoon-8IN-Shop-Section.png"}
                                                                    className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                                );
                                                            } else if (this.props.get_product_category(line.product) === "sealy-essential") {
                                                                return(
                                                                    <img src={ASSETS_URL + "/media/original_images/essentials-pillow-optimized.png"}
                                                                    className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                                );
                                                            } else if (this.props.get_product_category(line.product) === "sealy-premium") {
                                                                return(
                                                                    <img src={ASSETS_URL + "/media/original_images/premium-pillow-optimized.png"}
                                                                    className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                                );
                                                            } else if (this.props.get_product_category(line.product) === "sealy-performance") {
                                                                return(
                                                                    <img src={ASSETS_URL + "/media/original_images/performance-pillow-optimized.png"}
                                                                    className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                                );
                                                            }
                                                        })()
                                                    }
                                                    </a>
                                                </div>
                                                <div className="basket-line__details">

                                                {parseFloat(this.props.basket_lines[index].price_excl_tax_excl_discounts) > parseFloat(this.props.basket_lines[index].price_excl_tax)?
                                                    <React.Fragment >
                                                    <div className="basket-line__details__row">                                                        
                                                        <div
                                                            className="basket-line__details__column basket-line__details__column--product-detail">
                                                            <div className="basket-line__details__product-title">
                                                                <h3><a
                                                                        href={ this.props.get_product_category(line.product) === "cocoon-classic"?'/mattress/classic/':'/mattress/essential/' }>{ this.props.get_product_title(line.product) }</a></h3>
                                                            </div>
                                                            <div className="basket-line__details__options">
                                                                <ul></ul>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="basket-line__details__column basket-line__details__column--quantity-and-price">
                                                            <div className="basket-line__details__column--quantity">
                                                                <div className="basket-line__details__quantity">{this.props.userlang ==='fr'? 'Qté': 'Qty'}:
                                                                    &nbsp;<select data-id={index} value={this.props.basket_lines[index].quantity} onChange={this.props.update_product}>
                                                                        <option value="0">0</option>
                                                                        <option value="1">1</option>
                                                                        <option value="2">2</option>
                                                                        <option value="3">3</option>
                                                                        <option value="4">4</option>
                                                                        <option value="5">5</option>
                                                                        <option value="6">6</option>
                                                                        <option value="7">7</option>
                                                                        <option value="8">8</option>
                                                                        <option value="9">9</option>
                                                                        <option value="10">10</option>
                                                                    </select></div>
                                                            </div>
                                                            <div className="basket-line__details__column--base-price">${this.props.basket_lines[index].price_excl_tax_excl_discounts}
                                                            </div>
                                                        </div>

                                                        <div
                                                            className="basket-line__details__column basket-line__details__column--final-price">
                                                        
                                                            <div className="basket-line__details__price"><span
                                                                    className="basket-line__details__price--strike">${this.props.basket_lines[index].price_excl_tax_excl_discounts}</span>                                                            
                                                                <div className="basket-line-savings">
                                                                    <div className="basket-line-savings__summary"><a
                                                                            className="basket-line-savings__title basket-line-savings__summary-title accordion accordion--arrow" data-id={index} onClick={this.props.show_savings}>
                                                                                {this.props.userlang ==='fr'? 'Vos économies': 'Your Savings'}</a>
                                                                        <div
                                                                            className="basket-line-savings__total basket-line-savings__summary-total">
                                                                            -${
                                                                            ((parseFloat(this.props.basket_lines[index].price_excl_tax_excl_discounts) - parseFloat(this.props.basket_lines[index].price_excl_tax) )).toFixed(2) }</div>
                                                                    </div>
                                                                    {/* <div
                                                                        className="basket-line-savings__details accordion-target accordionTarget" data-id={'b' + index} onClick={this.show_savings}>
                                                                        <div className="basket-line-savings__detail">
                                                                            <div
                                                                                className="basket-line-savings__title basket-line-savings__detail-title">
                                                                                {this.state.basket.offer_discounts[0].name}</div>
                                                                            <div
                                                                                className="basket-line-savings__total basket-line-savings__detail-total">
                                                                                -${parseFloat(this.state.basket_lines[index].price_excl_tax) - parseFloat(this.state.basket_lines[index].price_excl_tax_excl_discounts)}</div>
                                                                        </div>
                                                                    </div> */}
                                                                    {/* {this.display_offer_content( this.state.basket_lines[index].quantity, index, this.discount_type( ( parseFloat(this.state.basket_lines[index].price_excl_tax_excl_discounts) - parseFloat(this.state.basket_lines[index].price_excl_tax) ) ) ) } */}
                                                                    -${ ((parseFloat(this.props.basket_lines[index].price_excl_tax_excl_discounts) - parseFloat(this.props.basket_lines[index].price_excl_tax) )).toFixed(2) }
                                                                </div>
                                                                
                                                                <span
                                                                className="basket-line__details__price--highlight">${this.props.basket_lines[index].price_excl_tax}</span>
                                                            </div>
                                                        

                                                        </div>                                                        
                                                    
                                                    </div>
                                                    </React.Fragment>
                                                    :
                                                    <React.Fragment >
                                                    <div class="basket-line__details__row">                                                    
                                                    <div
                                                        class="basket-line__details__column basket-line__details__column--product-detail">
                                                        <div class="basket-line__details__product-title">
                                                        <h3><a
                                                                href={ line.product }>{ this.props.get_product_title(line.product) }</a></h3>
                                                        </div>
                                                        <div class="basket-line__details__options">
                                                            <ul></ul>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="basket-line__details__column basket-line__details__column--quantity-and-price">
                                                        <div class="basket-line__details__column--quantity">
                                                            <div class="basket-line__details__quantity">{this.props.userlang ==='fr'? 'Qté': 'Qty'}:
                                                                &nbsp;<select data-id={index} value={this.props.basket_lines[index].quantity} onChange={this.props.update_product}>
                                                                    <option value="0">0</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                    <option value="6">6</option>
                                                                    <option value="7">7</option>
                                                                    <option value="8">8</option>
                                                                    <option value="9">9</option>
                                                                    <option value="10">10</option>
                                                                </select></div>
                                                        </div>
                                                        <div class="basket-line__details__column--base-price">${this.props.basket_lines[index].price_excl_tax_excl_discounts}
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="basket-line__details__column basket-line__details__column--final-price">
                                                        <div class="basket-line__details__price">${this.props.basket_lines[index].price_excl_tax_excl_discounts }</div>
                                                    </div>

                                                </div>
                                                </React.Fragment>
                                                }
                                                    <div
                                                        className="basket-line__details__row basket-line__details__row--border">
                                                        <div className="basket-line__details__controls">
                                                            <div className="basket-line__details__controls-loading">
                                                                <div className="sk-spinner sk-three-bounce">
                                                                    <div></div>
                                                                    <div></div>
                                                                    <div></div>
                                                                </div>
                                                            </div>
                                                        </div><button
                                                            className="basket-line__details__button basket-line__details__button--remove al-basket-line__button--remove" data-id={index} onClick={this.props.remove_product}>[({this.props.basket_lines[index].quantity}) {this.props.userlang ==='fr'? 'Retirer du panier': 'Remove from cart'}]</button>
                                                    </div>


                                                    {/* <div className="basket-line__details__row">
                                                        <div>
                                                            <div className="basket-suggestion">
                                                                <div
                                                                    className="basket-suggestion__row basket-suggestion__row--shaded">
                                                                    <h4>Complete Your Sleep Experience</h4>
                                                                </div>
                                                                <div className="basket-suggestion__row">
                                                                    <div className="basket-suggestion__graphic"><a
                                                                            href="https://www.cocoonbysealy.com/accessories/foundation/"><img
                                                                                src="https://assets-www.cocoonbysealy.com/media/images/products/2018/10/Cocoon-DropdownNav-Foundation.jpg"
                                                                                className="basket-line__graphic__image" alt="" /></a>
                                                                    </div>
                                                                    <div className="basket-suggestion__details">
                                                                        <h5>BEST SELLER for Cocoon by Sealy Chill</h5>
                                                                        <h4 className="basket-suggestion__details-title"><a
                                                                                href="https://www.cocoonbysealy.com/accessories/foundation/">Cocoon
                                                                                Foundation</a></h4>
                                                                        <div className="basket-suggestion__details__options">
                                                                            <ul>
                                                                                <li
                                                                                    className="basket-suggestion__details__option">
                                                                                    <span>Size</span>:
                                                                                    <strong>Queen</strong></li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                    <div className="basket-suggestion__price">
                                                                        <p>$299.00</p>
                                                                        <div className="basket-suggestion__financing"></div>
                                                                        <button
                                                                            className="button al-basket-addtocart-upsell">Add to
                                                                            cart</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                        {/* <div className="basket-line__details__suggestion-controls">
                                                            <button disabled="">&lt;</button>
                                                            <span className="basket-line__details__suggestion-controls__circles"> */}
                                                                {/* SVG goes here */}
                                                                {/* {svg_suggestions()} */}
                                                            {/* </span>
                                                            <button>&gt;</button>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        ))}  
                                        {/** END of Basket Item Row */}

                                        {/* <div className="basket-line basket-line--full transition--fade-enter-done">
                                            <div className="basket-line__graphic"><a
                                                    href="https://www.cocoonbysealy.com/mattress/chill-experience/"><img
                                                        src="https://assets-www.cocoonbysealy.com/media/images/products/2018/11/BundleImag2.jpg"
                                                        className="basket-line__graphic__image" alt="" /></a></div>
                                            <div className="basket-line__details">
                                                <div className="basket-line__details__row">
                                                    <div
                                                        className="basket-line__details__column basket-line__details__column--product-detail">
                                                        <div className="basket-line__details__product-title">
                                                            <h3><a
                                                                    href="https://www.cocoonbysealy.com/mattress/chill-experience/v/47/">The
                                                                    Chill Experience, Queen</a></h3>
                                                        </div>
                                                        <div className="basket-line__details__options">
                                                            <ul></ul>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="basket-line__details__column basket-line__details__column--quantity-and-price">
                                                        <div className="basket-line__details__column--quantity">
                                                            <div className="basket-line__details__quantity">Qty:
                                                                &nbsp;<select>
                                                                    <option value="0">0</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                    <option value="6">6</option>
                                                                    <option value="7">7</option>
                                                                    <option value="8">8</option>
                                                                    <option value="9">9</option>
                                                                    <option value="10">10</option>
                                                                </select></div>
                                                        </div>
                                                        <div className="basket-line__details__column--base-price">$0.00
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="basket-line__details__column basket-line__details__column--final-price">
                                                        <div className="basket-line__details__price">$0.00</div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="basket-line__details__row basket-line__details__row--border">
                                                    <div className="basket-line__details__controls">
                                                        <div className="basket-line__details__controls-loading">
                                                            <div className="sk-spinner sk-three-bounce">
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                            </div>
                                                        </div>
                                                    </div><button
                                                        className="basket-line__details__button basket-line__details__button--remove al-basket-line__button--remove">[Remove
                                                        from cart]</button>
                                                </div>
                                            </div>
                                        </div> */}


                                    </div>
                                </div>
                            </div>
                            {/* <div id="basket-lines__fine-print" className="basket-lines__fine-print">
                                <p><b>0% APR for 12 Months with equal payments</b><b><sup>1</sup></b><br /><sup>1</sup>The
                                    Cocoon by Sealy credit card is issued by Wells Fargo Bank, N.A. Special terms apply
                                    to qualifying purchases of $500 or more charged with approved credit. The special
                                    terms APR will continue to apply until all qualifying purchases are paid in full.
                                    The monthly payment for this purchase will be the amount that will pay for the
                                    purchase in full in equal payments during the promotional (special terms) period.
                                    The APR for Purchases will apply to certain fees such as a late payment fee or if
                                    you use the card for other transactions. For new accounts, the APR for Purchases is
                                    28.99%. If you are charged interest in any billing cycle, the minimum interest
                                    charge will be $1.00. This information is accurate as of 08/01/2019 and is subject
                                    to change. For current information, call us at 1-800-431-5921. Offer expires
                                    12/31/2019.</p>
                                <p><sup>2</sup>Monthly payment is based on purchase price alone excluding taxes. Credit
                                    purchases subject to credit approval. Other transactions may affect the monthly
                                    payment. Offer expires 12/31/2019. Ask for details.</p>
                                <p></p>
                                <p><br /></p>
                                <p></p>
                                <p></p>
                                <p><br /></p>
                                <p><br /></p>
                            </div> */}
                        </div>
                        <div>
                            <div style={{ paddingBottom: '0px' }}></div>
                            <div style={{ transform: `translateZ(${0}px)` }}>
                                <div className="basket-summary">
                                    <h2 className="basket-summary__header">{this.props.userlang ==='fr'? 'Résumé de la commande': 'Order Summary'}</h2>
                                    <div className="">
                                        <div className="basket-summary__prices">
                                            <div className="basket-summary-line">
                                                <div className="basket-summary-line__title">{this.props.userlang ==='fr'? 'Sous-total': 'Subtotal'}</div>
                                                <div className="basket-summary-line__data">${this.props.basket.total_excl_tax_excl_discounts}</div>
                                            </div>
                                            {
                                                    parseFloat(this.props.basket.total_excl_tax_excl_discounts) - parseFloat(this.props.basket.total_excl_tax) > 0?
                                                    
                                            <div className="basket-summary-line">                                                
                                                <div className="basket-savings" >
                                                    <div className="basket-savings__header">
                                                        <div className="basket-savings__title ">{this.props.userlang ==='fr'? 'Vos économies': 'Your Savings'}<span
                                                        className="accordion">{svg_question_mark()}</span></div>
                                                        <div className="basket-savings__info accordion-target">
                                                            <p>Promotional codes apply towards retail value only.</p>
                                                            <p>To maximize your savings, site wide offers will
                                                                automatically apply to any remaining balance.</p>
                                                        </div>
                                                    </div>                                                    
                                                    {this.props.basket.offer_discounts.map( (line, index) => (
                                                    <React.Fragment>
                                                    <div className="basket-savings__details">
                                                        
                                                        <div className="basket-savings__detail">
                                                            <div
                                                                className="basket-savings__title basket-savings__detail-title">
                                                                <span id="offner-name">{line.name}</span></div>
                                                            <div
                                                                className="basket-savings__total basket-savings__detail-total">
                                                                -${line.amount}</div>
                                                        </div>
                                                    </div>
                                                    </React.Fragment>
                                                    ))
                                                    }

                                                    {this.props.basket.voucher_discounts.map( (line, index) => ( 
                                                    <React.Fragment>
                                                    <div className="basket-savings__details">
                                                        
                                                        <div className="basket-savings__detail">
                                                            <div
                                                                className="basket-savings__title basket-savings__detail-title">
                                                                <span id="voucher-name">{line.name}</span></div>
                                                            <div
                                                                className="basket-savings__total basket-savings__detail-total">
                                                                -${line.amount}</div>
                                                        </div>
                                                    </div>
                                                    </React.Fragment>
                                                    ))
                                                    }
                                                    
                                                </div>                                                
                                            </div>
                                                :
                                                ''       
                                            }
                                            <div className="basket-summary-line">
                                                <div className="basket-summary-line__title">{this.props.userlang ==='fr'? 'Expédition': 'Shipping'}</div>
                                                <div className="basket-summary-line__data">{this.props.userlang ==='fr'? 'FREE': 'FREE'}</div>
                                            </div>
                                            <div className="basket-summary-line">
                                                <div className="basket-summary-line__title">{this.props.userlang ==='fr'? 'Taxe sur les ventes': 'Sales Tax'}</div>
                                                <div className="basket-summary-line__data">-</div>
                                            </div>
                                            <div className="basket-summary-line">
                                                <div
                                                    className="basket-summary-line__title basket-summary-line__title--total">
                                                    Total</div>
                                                <div className="basket-summary-line__data">${this.props.basket.total_excl_tax}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="basket-summary__promocode">
                                        <form className="form">
                                            <div className="basket-summary__promocode-form">
                                            <div className="form__field form__field--has-errors">
                                                <ul id="undefined_errors" className="form__error-list">
                                                {
                                            
                                                    this.props.promo_code_error.map( (line, index) => (line))
                                                
                                                } 
                                                </ul>
                                            </div>
                                                <div className="form__field"></div>
                                                <div className="form__field form__field--text"><label
                                                        className="form__label form__label--outside"
                                                        htmlFor="checkout-promo-code"
                                                        id="id-hatemile-association-2467340660673191-0">{this.props.userlang ==='fr'? 'Ajoutez un code promotionnel': 'Enter a Promo Code'}<span className="force-read-after"
                                                            data-attributerequiredof="checkout-promo-code"></span></label><input id="checkout-promo-code"
                                                        type="text" placeholder="" required=""
                                                        aria-label="Enter a Promo Code"
                                                        aria-labelledby="id-hatemile-association-2467340660673191-0"
                                                        aria-required="true" /></div>
                                                <div className="form__field form__field--submit"><input type="submit"
                                                        className="button button--inverse button--full-width basket-summary__promocode-submit"
                                                        value={this.props.userlang ==='fr'? 'Apply': 'Apply'} onClick={this.props.add_promo_code} /></div>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="basket-summary__buttons">
                                        {
                                            this.props.basketLoaded?
                                        <div className="basket-summary__checkout al-basket-summary__checkout"><a
                                                href={this.props.basketLoaded?this.props.checkout_url:'#'}
                                                className="button button--full-width"
                                                id="basket-summary__checkout--shop-tracking">{this.props.userlang ==='fr'? 'Payer': 'Checkout'}</a></div>
                                        :
                                        ''
                                        }
                                        <div className="basket-summary__continue-shopping al-basket__continue-shopping"><a
                                                href={this.props.home_url}
                                                className="button button--full-width button--inverse">{this.props.userlang ==='fr'? 'Poursuivre le magasinage': 'Continue Shopping'}</a>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="basket-summary__help">
                                            <h3>{this.props.userlang ==='fr'? 'Des questions': 'Questions?'}</h3>
                                            <p>{this.props.userlang ==='fr'? 'Appelez le': 'Call'} <a href="tel:+1-800-268-4414">(800) 268-4414</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }    
}

function svg_suggestions (props) {
    return (        
        <React.Fragment>
        <svg
            version="1.1" 
            id="Layer_2" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className="feel-scale-circles__item"
        >
            <use href="#icon-circle"></use>
            <title>Tempur Icon</title>
        </svg>        
        <svg
            version="1.1" 
            id="Layer_3" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className="feel-scale-circles__item feel-scale-circles__item--filled"
        >
            <use href="#icon-circle"></use>
            <title>Tempur Icon</title>
        </svg>
        </React.Fragment>
    );
}

function svg_question_mark (props) {
    return(
        <svg
            version="1.1" 
            id="Layer_4" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className="basket-savings__title-icon"
        >
            <use href="#icon-question-mark-circle"></use>
            <title>Tempur Icon</title>
        </svg>
    )
}

export default Basketitems;